
import { Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import EventCheckin from "@/pages/EventCheckin";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Onboarding from "@/pages/Onboarding";
import Offers from "@/pages/Offers";
import Wrapped from "@/pages/Wrapped";
import Circle from "@/pages/Circle";
import CircleEventDetail from "@/pages/CircleEventDetail";
import ThankYou from "@/pages/ThankYou";
import Checkout from "@/pages/Checkout";
import InterestRedirect from "@/pages/InterestRedirect";
import SeriesUnsubscribed from "@/pages/SeriesUnsubscribed";
import Feedback from "@/pages/Feedback";
import FriendInvite from "@/pages/FriendInvite";
// import CreativeChallenge from "@/pages/CreativeChallenge";
// import ArtistTalk from "@/pages/ArtistTalk";
// import NewFriend from "@/pages/NewFriend";
// import NewPlace from "@/pages/NewPlace";
// import NewArtist from "@/pages/NewArtist";
// import InviteFriend from "@/pages/InviteFriend";
// import TreasureHunt1 from "@/pages/TreasureHunt1";
// import TreasureHunt2 from "@/pages/TreasureHunt2";
// import Quiz1 from "@/pages/Quiz1";
// import Quiz2 from "@/pages/Quiz2";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import AdminRoute from "@/components/auth/AdminRoute";
import GuestOnlyRoute from "@/components/auth/GuestOnlyRoute";

const AppRoutes = () => {
  return (
    <Routes>
      {/* protect routes */}
      <Route path="/onboarding" element={protect(<Onboarding />)} />
      <Route path="/profile" element={protect(<Profile />)} />
      <Route path="/wrapped" element={protect(<Wrapped />)} />
      <Route path="/circle" element={protect(<Circle />)} />
      <Route path="/circle/:id" element={protect(<CircleEventDetail />)} />

      {/* guest-only routes */}
      <Route path="/auth" element={guestOnly(<Auth />)} />

      {/* public routes */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/:id" element={<EventDetail />} />
      <Route path="/events/:id/checkin" element={protect(<EventCheckin />)} />
      <Route path="/offers" element={<Offers />} />
      <Route path="/offers/:slug" element={<Offers />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/checkout" element={protect(<Checkout />)} />
      <Route path="/interest/:slug" element={<InterestRedirect />} />
      <Route path="/unsubscribed" element={<SeriesUnsubscribed />} />
      <Route path="/feedback" element={protect(<Feedback />)} />
      <Route path="/invite/:token" element={<FriendInvite />} />

      {/* BINGO ROUTES - DISABLED */}
      {/* <Route path="/progress" element={<Progress />} /> */}
      {/* <Route path="/creative-challenge" element={<CreativeChallenge />} /> */}
      {/* <Route path="/artist-talk" element={<ArtistTalk />} /> */}
      {/* <Route path="/new-friend" element={<NewFriend />} /> */}
      {/* <Route path="/new-place" element={<NewPlace />} /> */}
      {/* <Route path="/new-artist" element={<NewArtist />} /> */}
      {/* <Route path="/invite-friend" element={<InviteFriend />} /> */}
      {/* <Route path="/treasure-hunt-1" element={<TreasureHunt1 />} /> */}
      {/* <Route path="/treasure-hunt-2" element={<TreasureHunt2 />} /> */}
      {/* <Route path="/quiz-1" element={<Quiz1 />} /> */}
      {/* <Route path="/quiz-2" element={<Quiz2 />} /> */}

      {/* admin routes */}
      <Route path="/admin" element={admin(<Admin />)} />
    </Routes>
  );
};

function protect(element: JSX.Element) {
  return (
    <ProtectedRoute>
      {element}
    </ProtectedRoute>
  );
}

function admin(element: JSX.Element) {
  return (
    <AdminRoute>
      {element}
    </AdminRoute>
  );
}

function guestOnly(element: JSX.Element) {
  return (
    <GuestOnlyRoute>
      {element}
    </GuestOnlyRoute>
  );
}

export default AppRoutes;
